import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceAll',
    standalone: false
})
export class ReplaceAllPipe implements PipeTransform {
  transform(text: string, target: string, replacement: string): string {
  if (typeof text !== 'string' || typeof target !== 'string') {
    return text;
  }

  // becuase we currently don't support 'string.replaceAll' (es2018), the 
  // following regex patterns with the global flag are used to match and 
  // replace ALL targets

  const escapedTarget = target.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(escapedTarget, 'g');
  
  return text.replace(regex, replacement);
  }
}
